module.exports = __webpack_public_path__ + "static/media/logo.a9455f70.svg";